import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getByTableName = (params, urlParams) => {
  return axios.request({
    url: '/upc/webtablecolumns/getbytablename/' + params.tableName + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const saveWebTableColumns = (params, urlParams) => {
  return axios.request({
    url: '/upc/webtablecolumns/savewebtablecolumns' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/upc/webtablecolumns/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/upc/webtablecolumns/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/upc/webtablecolumns/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getMyAll = (params, urlParams) => {
  return axios.request({
    url: '/upc/webtablecolumns/getmyall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

